// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class SeqId {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SeqId {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  site(): number {
    return this.bb!.readUint16(this.bb_pos)
  }

  timestamp(): number {
    return this.bb!.readUint32(this.bb_pos + 4)
  }

  index(): number {
    return this.bb!.readUint32(this.bb_pos + 8)
  }

  static sizeOf(): number {
    return 12
  }

  static createSeqId(builder: flatbuffers.Builder, site: number, timestamp: number, index: number): flatbuffers.Offset {
    builder.prep(4, 12)
    builder.writeInt32(index)
    builder.writeInt32(timestamp)
    builder.pad(2)
    builder.writeInt16(site)
    return builder.offset()
  }
}
